import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "content-block"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Marker = _resolveComponent("Marker")!
  const _component_GoogleMap = _resolveComponent("GoogleMap")!

  return (_ctx.address)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "mb-4" }, " Location ", -1)),
        _createElementVNode("p", null, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.address), 1)
        ]),
        _createVNode(_component_GoogleMap, {
          "api-key": _ctx.getKey(),
          class: "property-location",
          center: _ctx.mapCenter,
          zoom: 14,
          "zoom-control": true,
          "map-type-control": false,
          "scale-control": false,
          "street-view-control": false,
          "rotate-control": false,
          "fullscreen-control": false
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Marker, {
              options: {
          position: _ctx.mapCenter,
          icon: require('@/assets/svg/marker.svg')
        }
            }, null, 8, ["options"])
          ]),
          _: 1
        }, 8, ["api-key", "center"])
      ]))
    : _createCommentVNode("", true)
}